import React, { useEffect } from 'react';
import { Gem, Loader2 } from 'lucide-react';
import Button from './ui/Button';

const SimpleLoadingModal = ({ isOpen }) => {
  useEffect(() => {
    if (!isOpen) return;
    const timer = setTimeout(() => {
      window.location.href = '/tokens';
    }, 3000);
    return () => clearTimeout(timer);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-zinc-900 p-8 text-center shadow-2xl">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-rose-500/15">
          <Loader2 className="h-7 w-7 animate-spin text-rose-400" />
        </div>
        <h2 className="mb-4 flex items-center justify-center gap-2 text-lg font-semibold text-white">
          <Gem className="h-5 w-5 text-rose-400" /> Carregando tokens
        </h2>
        <Button
          onClick={() => {
            window.location.href = '/tokens';
          }}
          fullWidth
        >
          Ir para tokens agora
        </Button>
      </div>
    </div>
  );
};

export default SimpleLoadingModal;
